import axios from 'axios';

export default {
  data() {
    return {
      destinationData: typeof(this.destination) === 'object' ? this.destination : {}
    }
  },
  props: {
    destination: {
      type: [Object, String],
      required: false
    }
  },
  watch: {
    destination: {
      immediate: true,
      async handler(destination) {
        if (typeof destination === 'object') {
          this.destinationData = destination;
        } else if (typeof destination === 'string') {
          const { data } = await axios.get(`/api/locations/${destination}`);
          this.destinationData = data;
        }
      }
    }
  },
  methods: {
    goDestinationBlog() {
      window.location.href = `/blog?destino=${this.destinationData.slug}`;
    }
  }
};
